// extracted by mini-css-extract-plugin
export var quantityInput = "_ov-0";